import { render, staticRenderFns } from "./HonorSection.vue?vue&type=template&id=95b6e5ae&scoped=true&"
import script from "./HonorSection.vue?vue&type=script&lang=js&"
export * from "./HonorSection.vue?vue&type=script&lang=js&"
import style0 from "./HonorSection.vue?vue&type=style&index=0&id=95b6e5ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b6e5ae",
  null
  
)

export default component.exports